// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function safetypayCashOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'safetypay-cash',
    payment_type_code: 'safetypay-cash',
  };
}
